import { isObject } from '../isServiceError';
export class RedirectionInProgressFilter {
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    return !(isObject(cause) && 'message' in cause && typeof cause.message === 'string' && cause.message.toLowerCase().includes('aborting: redirection in progress'));
  }
}